import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Matt Stayner
 * id E88C3E97-A92F-4222-B649-01ABFB105FAF
 * name arrow-top-left-thin
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-top-left-thin.svg
 * tags
 * - Arrow 
 */
export const ArrowTopLeftThinIcon = createSvgIcon(<><path d="M12.07 5L9.24 7.83L19 17.59L17.58 19L7.82 9.25L5 12.07V5Z" /></>, 'ArrowTopLeftThinIcon');
export default ArrowTopLeftThinIcon